import axios from 'axios';
import type {
  IGetKeyholderBalanceParams,
  IGetKeyholderBalanceRequest,
  IGetKeyholderBalanceResponse,
} from '@/app-package';

const getKeyholderBalance = async (params: IGetKeyholderBalanceParams) => {
  const config: IGetKeyholderBalanceRequest = {
    url: `/supra/keyholder_balance/${params.billingCustomerNumber}`,
    method: 'get',
  };
  try {
    const { data } = await axios.request<IGetKeyholderBalanceResponse | null>(
      config,
    );
    return data;
  } catch (error: any) {
    // Check for 404 error and return a nulled object
    if (error.response && error.response.status === 404) {
      return {
        outstandingBalance: null,
        currencyCode: null,
        paymentDueDate: null,
      };
    }
    throw error;
  }
};

export default getKeyholderBalance;
